module.exports = __webpack_public_path__ + "static/media/accordion-left.75f8f165.svg";